import { createTheme } from "@material-ui/core/styles";
import NowRegularFont from "./assets/fonts/Now-Regular.otf";
import NowMediumFont from "./assets/fonts/Now-Medium.otf";
import NowBoldFont from "./assets/fonts/Now-Bold.otf";

const NowRegular = {
  fontFamily: "Now",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 400,
  src: `
    local('NowRegular'),
    local('NowRegular'),
    url(${NowRegularFont}) format('opentype')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const NowMedium = {
  fontFamily: "Now",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 500,
  src: `
    local('NowMedium'),
    local('NowMedium'),
    url(${NowMediumFont}) format('opentype')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const NowBold = {
  fontFamily: "Now",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 700,
  src: `
    local('NowBold'),
    local('NowBold'),
    url(${NowBoldFont}) format('opentype')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const theme = createTheme({
  palette: {
    primary: { 500: "#F9D13B" },
    background: { default: "#F1F2F6" },
    secondary: { main: "#da0303" },
    success: { 500: "#9ddb64" },
  },
  typography: {
    fontFamily: "Now, Arial",
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [NowRegular, NowMedium, NowBold],
      },
    },
    MuiFormLabel: {
      root: {
        color: "#000",
        lineHeight: "0",
        fontFamily: "Now",
      },
    },
    MuiInput: {
      root: {
        backgroundColor: "#FCFDFE",
        borderRadius: "2px",
        border: "1px solid #E4E7EB",
      },
    },
    MuiButton: {
      root: {
        fontFamily: "Now",
        fontWeight: 500,
        background: "#F9D13B",
        borderRadius: "4px",
        border: 0,
        height: 38,
        textTransform: "unset",
        boxShadow: "unset",
      },
      textPrimary: {
        color: "#000",
      },
      contained: {
        color: "#000",
        boxShadow: "unset",
      },
      containedPrimary: {
        color: "#000",
        "&:hover": {
          backgroundColor: "#F9D13B",
        },
      },
      outlined: {
        color: "#000",
        border: "2px solid #000"
      },
    },
    MuiAvatar: {
      root: {
        color: "#5b5a5a!important",
        backgroundColor: "#e6ebf1!important",
        paddingTop: "5px",
      },
    },
  },
});

export default theme;
